import { useState } from "react";

export default function Contact(){
  const [ok, setOk] = useState(false);
  const [form, setForm] = useState({nombre:"", email:"", mensaje:""});

  const onChange = (e)=> setForm({...form, [e.target.name]: e.target.value});
  const onSubmit = (e)=>{
    e.preventDefault();
    setOk(true);
    setTimeout(()=> setOk(false), 2500);
    setForm({nombre:"", email:"", mensaje:""});
  };

  return (
    <main className="container">
      <div className="grid grid-2">
        <div className="card">
          <h2 style={{marginTop:0}}>Contactos</h2>
          <p className="p">Escríbenos para colaboraciones, pautas o ideas.</p>
          <p className="p" style={{marginBottom:0}}>
            Email: contacto@showbanqueras.com <br/>
            WhatsApp: +1 (809) 000-0000
          </p>
        </div>

        <form className="card" onSubmit={onSubmit}>
          <h3 style={{marginTop:0}}>Formulario</h3>

          <input className="card" style={{width:"100%", padding:12}} placeholder="Nombre"
            name="nombre" value={form.nombre} onChange={onChange} required />
          <div style={{height:10}} />
          <input className="card" style={{width:"100%", padding:12}} placeholder="Email"
            name="email" value={form.email} onChange={onChange} required />
          <div style={{height:10}} />
          <textarea className="card" style={{width:"100%", padding:12, minHeight:120}} placeholder="Mensaje"
            name="mensaje" value={form.mensaje} onChange={onChange} required />
          <div style={{height:10}} />

          <button className="btn btn-blue" type="submit" style={{width:"100%", justifyContent:"center"}}>
            Enviar
          </button>

          {ok && <div style={{marginTop:12, color:"var(--green)"}}>✅ Mensaje enviado</div>}
        </form>
      </div>
    </main>
  );
}
